import { atom } from "jotai";

export const evaluacionesAtom = atom([]);
export const evaluacionSeleccionadaAtom = atom(undefined);
export const visibleModalAprobarEvaluacionAtom = atom(undefined);

export const planesAccionAtom = atom ([]);
export const filtroEstadoPlanAccionAtom = atom(undefined);
